import { ReasonCode } from "types/landlord/reports";

export interface W2InscribeAdditionalData {
  type_mismatch?: boolean;
  provided_type?: string;
  is_name_present?: boolean;
  low_quality_score?: boolean;
  not_w2?: boolean;
  wrong_year?: boolean;
  high_risk_level?: boolean;
  risk_level?: "LOW" | "MEDIUM" | "HIGH" | "NOT_APPLICABLE";
  risk_assessment_summary?: string;
}

export const getW2InscribeReasonCodes = (
  additionalData?: W2InscribeAdditionalData | null
): ReasonCode[] => {
  if (!additionalData) return [];

  const warnings: ReasonCode[] = [];

  if (additionalData.type_mismatch)
    warnings.push({
      code: "",
      confidence: "HIGH",
      description: additionalData.provided_type
        ? `Wrong document type (${additionalData.provided_type})`
        : "Wrong document type"
    });

  if (additionalData.not_w2)
    warnings.push({
      code: "",
      confidence: "HIGH",
      description: "Tax form is not a W2"
    });

  if (additionalData.wrong_year)
    warnings.push({
      code: "",
      confidence: "HIGH",
      description: "W2 is for the wrong tax year"
    });

  if (additionalData.low_quality_score)
    warnings.push({
      code: "",
      confidence: "HIGH",
      description: "The file is of poor quality"
    });

  if (additionalData.is_name_present === false)
    warnings.push({
      code: "",
      confidence: "HIGH",
      description: "No employee name detected on document"
    });

  return warnings;
};
